<template>
    <div id="konfigurator-alergie">

        <h1>Má {{ mazlicek.jmeno.value }} nějaké zdravotní obtíže?</h1>

        <div v-show="!isAlergieValid() && this.tryescape" class="info-messages-box">
            <div v-if="!isAlergieValid() && this.tryescape" class="error-msg">
                Vyberte alespoň jednu z možností
            </div>
        </div>

        <div class="form-content">

            <div class="konfigurator-alergie">

                <div class="form-radios">
                    <div class="form-type-radio" v-for="item in alergieItems">
                        <input type="radio" v-model="mazlicek.alergie.alergie" v-bind:value="item.val"
                               :id="String(item.val) + '-alergie'">
                        <label :for="String(item.val) + '-alergie'">
                            {{ item.label }}
                        </label>
                    </div>
                </div>
            </div>

            <div v-show="mazlicek.alergie.alergie" class="konfigurator-alergie-vypis">
                <div class="form-type-checkboxes" v-bind:class="{ 'has-error':!isAlergieValid() && this.tryescape }">
                    <div class="form-type-checkbox" v-for="item in alergenyItems" v-show="mazlicek.alergie.alergie">
                        <input type="checkbox" v-model="mazlicek.alergie.alergeny" v-bind:value="item.id" :id="item.id">
                        <label :for="item.id">
                            {{ item.title }}
                        </label>
                    </div>
                </div>
            </div>

        </div>

        <info :krok="8"></info>

        <navigace
                :showPrev="true"
                :onClickPrev="prev"
                :showNext="true"
                :disableNext="!valid"
                :onClickNext="next"
                :onClickSaveAndQuit="saveAndQuit"
        ></navigace>


    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {apiSilex} from '../api'
    import navigace from './Navigace'
    import info from './Info'

    export default {
        components: {navigace, info},
        mixins: [validationMixin],
        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                alergieItems: [
                    {label: 'Ano', val: true},
                    {label: 'Ne', val: false}
                ],
                alergenyItems: [],
                tryescape: false
            }
        },
        computed: {
            valid: function () {
                return (this.mazlicek.alergie.valid = !this.$v.mazlicek.alergie.$invalid)
            }
        },
        methods: {
            prev: function () {
                this.$router.push({name: 'pohyb'})
            },
            saveAndQuit: function () {
              if (this.isAlergieValid()) {
                this.mazlicek.suroviny.suroviny = []

                if (!this.mazlicek.alergie.alergie)
                  this.mazlicek.alergie.alergeny = []
                this.$store.dispatch('updatePet', this.mazlicek)
                  .then(response => {
                    this.mazlicek.alergie.valid = true
                    this.$store.commit('setMazlicek', this.mazlicek)
                    this.$cookies.set('show_confirmation_message', 1)
                    window.location.href = 'opet-objednej/' + this.mazlicek.nid
                  }, error => {
                    console.error(error)
                  })
              } else {
                this.tryescape = true
                this.animateAfterError()
              }
            },
            next: function () {
                if (this.isAlergieValid()) {
                    this.mazlicek.suroviny.suroviny = []

                    if (!this.mazlicek.alergie.alergie)
                        this.mazlicek.alergie.alergeny = []
                    // this.$store.commit('setMazlicek', this.mazlicek)
                    this.$store.dispatch('updatePet', this.mazlicek)
                        .then(response => {
                            this.mazlicek.alergie.valid = true
                            this.$store.commit('setMazlicek', this.mazlicek)
                            this.$router.push({name: 'suroviny'})
                        }, error => {
                            console.error(error)
                        })
                } else {
                    this.tryescape = true
                    this.animateAfterError()
                }
            },
            isAlergieValid: function () {
                return this.mazlicek.alergie.alergie === false || this.mazlicek.alergie.alergeny.length > 0
            },
            animateAfterError() {
                jQuery('html, body').animate({
                        scrollTop: jQuery('.app-content-left').offset().top - jQuery('#primary').height()
                    },
                    '500'
                )
            }
        },
        mounted: function () {
            this.mazlicek.step.current = 7
            this.$cookies.set('lastVisitedStep', 7)
            jQuery('html, body').animate({scrollTop: 0}, '500')
            apiSilex.get('/alergen').then(
                response => (this.alergenyItems = response.data)
            )
        },
        validations: {
            mazlicek: {
                alergie: {
                    valid: function () {
                        if (this.mazlicek.alergie.alergie) {
                            return (this.mazlicek.alergie.alergeny.length > 0)
                        } else if (!this.mazlicek.alergie.alergie) {
                            this.mazlicek.alergie.alergeny = []
                            return true
                        }
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// 08Alergie.vue?351457be